import {Component} from '@angular/core';
import {ProfileType} from '../../model/profile-type.model';
import {ConfigService} from '../../service/config.service';

@Component({
    selector: 'app-ifa-campaign',
    templateUrl: './ifa-campaign.component.html',
    styleUrls: ['./ifa-campaign.component.css']
})
export class IfaCampaignComponent {
    ProfileType = ProfileType;
    grey = 'grey';

    public async redirectToIfaHomePage() {
        const partnersFrontendUrl = ConfigService.getPartnersFrontendUrl();
        window.open(partnersFrontendUrl, '_blank');
    }
}
